import { connect } from "react-redux";
import Navbar from "../components/Navbar/Navbar";
import { setMainPage } from "../actions/app";
import { openHelp } from "../actions/research";
import { confirmLogout } from "../actions/auth";
import { openFileManager } from "../actions/filemanager";
import { setGameView } from "../actions/game";
import { GAME_PAGE_INTRO, GAME_PAGE_PROGRESS } from "../constants/game";

const mapStateToProps = state => {
  return {
    appName: state.app.name,
    page: state.app.page,
    gameMode: state.app.gameMode,
    game: state.game
  };
};

const mapDispatchToProps = dispatch => {
  return {
    gotoPage: page => dispatch(setMainPage(page)),
    logout: () => dispatch(confirmLogout()),
    openHelp: () => dispatch(openHelp()),
    openFileManager: () => dispatch(openFileManager()),
    showGameProgress: () => dispatch(setGameView(GAME_PAGE_PROGRESS)),
    showGameIntro: () => dispatch(setGameView(GAME_PAGE_INTRO))
  };
};

const Header = connect(mapStateToProps, mapDispatchToProps)(Navbar);

export default Header;
